export const USERKEY = "digital-week"